let clientIdValue = '';

export const setClientId = (clientId: string) => clientIdValue = clientId || '';

export const getClientId = () => clientIdValue;